<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense style="background:#F5F5F5">
        <v-toolbar-title dense style="color:#607D8B;font-weight:bold">Liste des règles</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="refresh" icon>
          <v-icon color="#009688" large>mdi-refresh</v-icon>
          <template v-slot:loader>
            <span class="custom-loader"> <v-icon light>cached</v-icon></span>
          </template>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-dialog fullscreen v-model="loading">
          <v-container fill-height fluid style="background-color: rgba(200, 200, 200, 0.5);">
            <v-layout align-center="true" justify-center="true">
              <v-progress-circular
                  :on-cancel="onCancel"
                  :size="70"
                  color="#009688"
                  indeterminate>
              </v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>
        <v-alert :color=AlertColor(type)
                 :dismissible=true
                 :value=true
                 @input="dismissible_close"
                 border="top"
                 class="pre-formatted multi-line"
                 colored-border
                 elevation="2"
                 icon="check_circle"
                 style="color: #546E7A"
                 v-if="type">
          {{ text }}
        </v-alert>
        <v-alert border="top" class="my-4" color="#F44336" dark dense v-if="errors.length>0"
                 v-model="alert">
          <h4 class="mt-2">{{ errors.length }}{{ " Erreur" | pluralize(errors.length) }}
            sur {{ excelData.length }} {{ "enregistrement"|pluralize(excelData.length) }}.
            Merci de corriger et de ne réimporter que les enregistrements ci-dessous rejetés, pour éviter
            tout doublon
          </h4>
          <v-row align="center">
            <v-col class="grow">
              <div :key="index" v-for="(error,index) in errors">
                <h5>
                  <v-icon>mdi-alert-circle</v-icon>
                  {{
                    "Nom Poste (" + error.datas.postName + ") - Nom Shift (" + error.datas.shiftName +
                    ") - Date dispatching (" + convertDate(error.datas.dispatchingDate) + ")"
                    + " -> " + error.message
                  }}
                </h5>
              </div>
            </v-col>
            <v-col class="shrink">
              <v-btn :elevation="1" @click="closeAlert" fab small
                     style="position:absolute;top:18px;right:12px">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-alert>
        <v-card class="mt-1" flat tile>
          <v-row>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col>
              <v-text-field :disabled="disableMainBtn"
                            :id="dynamicID()"
                            @change="search"
                            @keyup.native.enter="search"
                            @click:clear="cleared()"
                            append-icon="mdi-magnify"
                            class="centered-input align-center"
                            clearable
                            hide-details
                            placeholder="Recherche"
                            v-model="searchName">
              </v-text-field>
            </v-col>
            <v-col>
              <v-btn :disabled="disableMainBtn" @click="onexportModele" block
                     class="custom-btn white--text"
                     color="#03A9F4" height="45px"
                     large>
                <v-icon class="mr-1">mdi-download-circle-outline</v-icon>
                <span> Export modèle </span>
              </v-btn>
            </v-col>
            <v-col>
              <v-btn :disabled="disableMainBtn" @click="onexport" block class="custom-btn white--text"
                     color="#00BCD4"
                     height="45px" large>
                <v-icon class="mr-1">mdi-file-excel-outline</v-icon>
                <span>Export règles</span>
              </v-btn>
            </v-col>
            <v-col>
              <v-dialog max-width="600px" persistent v-model="dialog">
                <template @mouseleave.native="hover = false" @mouseover.native="hover = true"
                          v-slot:activator="{ on }">
                  <v-btn :disabled="disableMainBtn" @click="init()" block
                         class="custom-btn white--text"
                         color="#009688" height="45px"
                         large v-on="on">
                    <v-icon class="mr-1">mdi-plus-circle-outline</v-icon>
                    <span> Création règle </span>
                  </v-btn>
                </template>
                <v-card>
                  <v-toolbar
                      color="#01579B"
                      dark
                      flat>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="close"
                        dark
                        fab
                        small>
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-tabs :grow=true background-color="#01579B" color="#f5f5f5" dark="" right
                          v-model="tab">
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href="#tab-1"> Via un formulaire</v-tab>
                    <v-tab href="#tab-2"> Via un fichier excel</v-tab>
                  </v-tabs>
                  <v-tabs-items v-model="tab">
                    <v-tab-item value="tab-1">
                      <v-card-text>
                        <v-container>
                          <v-stepper v-model="e6" vertical>
                            <v-stepper-step :complete="e6 > 1" :editable="true" step="1">
                              Informations générales
                            </v-stepper-step>
                            <v-stepper-content step="1">
                              <v-row class="justify-center align-center">
                                <v-col md="9" sm="6">
                                  <v-select :items="namePosts"
                                            @change="loadPostes"
                                            class="centered-input align-center text-center"
                                            item-text="type" item-value="type"
                                            label="Nom du poste"
                                            v-model="editedItem.postName">
                                    <template v-slot:selection="{ item }">
                                                                          <span class="d-flex justify-center"
                                                                                style="width: 100%;">
                                                                            {{ item }}
                                                                          </span>
                                    </template>
                                  </v-select>
                                </v-col>
                              </v-row>
                              <v-row class="justify-center align-center">
                                <v-col cols="12" md="9" sm="6">
                                  <v-text-field :id="dynamicID()"
                                                class="centered-input align-center"
                                                disabled
                                                label="Nom de la zone"
                                                v-model="editedItem.zoneName">
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-btn @click="e6 = 2" class="mb-2"
                                     color="primary"><span
                                  class="material-icons"> done_all </span></v-btn>
                            </v-stepper-content>
                            <v-stepper-step :complete="e6 > 2" :editable="true"
                                            step="2">Répartition des agents
                            </v-stepper-step>
                            <v-stepper-content step="2">
                              <v-card flat>
                                <v-card-text>
                                  <v-row class="justify-center align-center">
                                    <v-col cols="12" md="9" sm="12">
                                      <v-text-field :id="dynamicID()"
                                                    class="centered-input align-center"
                                                    label="Nombre total agents"
                                                    type="number"
                                                    v-model="editedItem.nbrAgentsTotal">
                                      </v-text-field>
                                    </v-col>
                                  </v-row>
                                  <v-row>
                                    <v-col cols="12" md="4" sm="12">
                                      <v-text-field :id="dynamicID()"
                                                    class="centered-input align-center"
                                                    label="Homme X-Ray"
                                                    type="number"
                                                    v-model="editedItem.nbrMenXRay">
                                      </v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="4" sm="12">
                                      <v-text-field :id="dynamicID()"
                                                    class="centered-input align-center"
                                                    label="Femme X-Ray"
                                                    type="number"
                                                    v-model="editedItem.nbrWomenXRay">
                                      </v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="4" sm="12">
                                      <v-text-field :id="dynamicID()"
                                                    class="centered-input align-center"
                                                    label="Homme OJT X-Ray"
                                                    type="number"
                                                    v-model="editedItem.nbrMenOJTXRay">
                                      </v-text-field>
                                    </v-col>
                                  </v-row>
                                  <v-row>
                                    <v-col cols="12" md="4" sm="12">
                                      <v-text-field :id="dynamicID()"
                                                    class="centered-input align-center"
                                                    label="Femme OJT X-Ray"
                                                    type="number"
                                                    v-model="editedItem.nbrWomenOJTXRay">
                                      </v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="4" sm="12">
                                      <v-text-field :id="dynamicID()"
                                                    class="centered-input align-center"
                                                    label="H/F OJT X-Ray"
                                                    type="number"
                                                    v-model="editedItem.nbrOJTXRay">
                                      </v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="4" sm="12">
                                      <v-text-field :id="dynamicID()"
                                                    class="centered-input align-center"
                                                    label="H/F X-Ray"
                                                    type="number"
                                                    v-model="editedItem.nbrXRay">
                                      </v-text-field>
                                    </v-col>
                                  </v-row>
                                  <v-row>
                                    <v-col cols="12" md="4" sm="12">
                                      <v-text-field :id="dynamicID()"
                                                    class="centered-input align-center"
                                                    label="Homme Base"
                                                    type="number"
                                                    v-model="editedItem.nbrMenBased">
                                      </v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="4" sm="12">
                                      <v-text-field :id="dynamicID()"
                                                    class="centered-input align-center"
                                                    label="Femme Base"
                                                    type="number"
                                                    v-model="editedItem.nbrWomenBased">
                                      </v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="4" sm="12">
                                      <v-text-field :id="dynamicID()"
                                                    class="centered-input align-center"
                                                    label="H/F Base"
                                                    type="number"
                                                    v-model="editedItem.nbrWomenBased">
                                      </v-text-field>
                                    </v-col>
                                  </v-row>
                                  <v-row>
                                    <v-col cols="12" md="4" sm="12">
                                      <v-text-field :id="dynamicID()"
                                                    class="centered-input align-center"
                                                    label="Homme OJT Base"
                                                    type="number"
                                                    v-model="editedItem.nbrMenOJTBased">
                                      </v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="4" sm="12">
                                      <v-text-field :id="dynamicID()"
                                                    class="centered-input align-center"
                                                    label="Femme OJT Base"
                                                    type="number"
                                                    v-model="editedItem.nbrWomenOJTBased">
                                      </v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="4" sm="12">
                                      <v-text-field :id="dynamicID()"
                                                    class="centered-input align-center"
                                                    label="H/F OJT Base"
                                                    type="number"
                                                    v-model="editedItem.nbrOJTBased">
                                      </v-text-field>
                                    </v-col>
                                  </v-row>
                                  <v-row>
                                    <v-col cols="12" md="4" sm="12">
                                      <v-text-field :id="dynamicID()"
                                                    class="centered-input align-center"
                                                    label="Homme Formé"
                                                    type="number"
                                                    v-model="editedItem.nbrMenFormed">
                                      </v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="4" sm="12">
                                      <v-text-field :id="dynamicID()"
                                                    class="centered-input align-center"
                                                    label="Femme Formée"
                                                    type="number"
                                                    v-model="editedItem.nbrWomenFormed">
                                      </v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="4" sm="12">
                                      <v-text-field :id="dynamicID()"
                                                    class="centered-input align-center"
                                                    label="H/F Formé(e)"
                                                    type="number"
                                                    v-model="editedItem.nbrFormed">
                                      </v-text-field>
                                    </v-col>
                                  </v-row>
                                  <v-row>
                                    <v-col cols="12" md="6" sm="12">
                                      <v-text-field :id="dynamicID()"
                                                    class="centered-input align-center"
                                                    label="Chefs de poste"
                                                    type="number"
                                                    v-model="editedItem.nbrChefPost">
                                      </v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="6" sm="12">
                                      <v-text-field :id="dynamicID()"
                                                    class="centered-input align-center"
                                                    label="Superviseurs"
                                                    type="number"
                                                    v-model="editedItem.nbrSupervisor">
                                      </v-text-field>
                                    </v-col>
                                  </v-row>
                                  <v-row>
                                    <v-col cols="12" md="6" sm="12">
                                      <v-text-field :id="dynamicID()"
                                                    class="centered-input align-center"
                                                    label="Commandant de Permanence"
                                                    type="number"
                                                    v-model="editedItem.nbrComDePerm">
                                      </v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="6" sm="12">
                                      <v-text-field :id="dynamicID()"
                                                    class="centered-input align-center"
                                                    label="Chauffeurs"
                                                    type="number"
                                                    v-model="editedItem.nbrChauffeur">
                                      </v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="6" sm="12">
                                      <v-text-field :id="dynamicID()"
                                                    class="centered-input align-center"
                                                    label="Chefs de Brigade"
                                                    type="number"
                                                    v-model="editedItem.nbrChefBrigade">
                                      </v-text-field>
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                              </v-card>
                              <v-btn @click="e6 = 4" class="mb-2" color="primary">
                                <span class="material-icons"> done_all </span></v-btn>
                            </v-stepper-content>
                          </v-stepper>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn :disabled="!FormIsValid && !loading" @click="creer"
                               class="white--text"
                               color="#01579B" depressed>Créer règle
                        </v-btn>
                      </v-card-actions>
                    </v-tab-item>
                    <v-tab-item value="tab-2">
                      <v-card v-if="!file">
                        <v-container v-if="loading">
                          <div class="text-center">
                            <v-progress-circular color="green" indeterminate>
                            </v-progress-circular>
                          </div>
                        </v-container>
                        <v-btn :disabled="!fileBtn" @click="onPickFile" block
                               class="mr-2 mb-2"
                               large style="color:#01579B; background-color:#F5F5F5"
                               v-if="!loading">
                          <v-icon>mdi-paperclip</v-icon>
                          Importer ICI ou Glisser/Copier le fichier Excel ci-dessous
                        </v-btn>
                        <input @change="onFilePicked($event)" accept="xlsx/*" id="upload"
                               ref="fileInput"
                               style="display:none" type="file"/>
                      </v-card>
                      <v-card>
                        <div class="text-center">
                          <v-card-text>
                            <v-chip color="white" disabled label small
                                    v-if="file">
                              {{ file.name }} ({{ file.size | kb }} kb)
                            </v-chip>
                            <v-btn @click="removeFile(file)"
                                   title="Supprimer"
                                   v-if="file">
                              <v-icon style="color:mediumvioletred;">
                                mdi-delete-circle-outline
                              </v-icon>
                            </v-btn>
                            <template>
                              <div ref="others">
                                <div :class="['downbox', drag_over ? 'over' : '']"
                                     @dragenter="dragEnter"
                                     @dragleave="dragLeave"
                                     @dragover.prevent
                                     @drop.prevent="addFile"
                                     @ondragover="dragOver"
                                     v-cloak>
                                  <v-btn
                                      color="primary"
                                      height="100px"
                                      outlined
                                      v-if="!file"
                                      width="100%"
                                  >
                                  </v-btn>
                                </div>
                              </div>
                              <v-spacer></v-spacer>
                              <v-btn :disabled="loading" :loading="loading"
                                     @click.prevent="importFileToHandsonTable"
                                     color="#009688" dark
                                     depressed
                                     fab
                                     v-if="file">
                                <v-icon>mdi-cloud-upload</v-icon>
                                <span class="custom-loader" slot="loader">
                                                                        <v-icon color="white" light>cached</v-icon>
                                                                        </span>
                              </v-btn>
                            </template>
                          </v-card-text>
                        </div>
                      </v-card>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-4"
                elevation="6">
          <hot-table :settings="hotSettings" ref="hotTable"></hot-table>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import {HotTable} from "@handsontable/vue";
import "handsontable/languages/fr-FR";
import apiClient from "../../../config/api.js";
import moment from "moment"
import "vue-loading-overlay/dist/vue-loading.css";
import * as XLSX from 'xlsx';
import Handsontable from "handsontable";

function customDropDownRender(instance, td, row, col, prop, value, cellProperties) {
  Handsontable.renderers.AutocompleteRenderer.apply(this, arguments);
  cellProperties.data = 'options';
  cellProperties.type = 'dropdown';

  if (col === 1) {
    cellProperties.source = JSON.parse(sessionStorage.getItem("PostesEnabled"));
  }
}

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  name: "dispatching_rules",
  components: {HotTable},
  data: function () {
    return {
      isMobile: isMobileDevice(),
      disableMainBtn: false,
      searchName: "",
      shifts: [],
      shiftsFull: [],
      namePostsZones: [],
      namePosts: [],
      nameZones: [],
      dialogTmp: false,
      fileBtn: true,
      drag_over: false,   // dragging over the target OR any child element
      over_others: false, // dragging over a child element
      files: [],
      lastHighlitedRow: null,
      menu: null,
      type: null,
      elapse: null,
      loading: false,
      menustartWorkingDate: false,
      toObject: [],
      editedItem: {
        id: "",
        postName: "",
        zoneName: "",
        nbrAgentsTotal: 0,
        nbrWomenBased: 0,
        nbrMenBased: 0,
        nbrWomenOJTBased: 0,
        nbrMenOJTBased: 0,
        nbrOJTBased: 0,
        nbrBased: 0,
        nbrMenFormed: 0,
        nbrWomenFormed: 0,
        nbrFormed: 0,
        nbrWomenXRay: 0,
        nbrMenXRay: 0,
        nbrWomenOJTXRay: 0,
        nbrMenOJTXRay: 0,
        nbrOJTXRay: 0,
        nbrXRay: 0,
        nbrChefPost: 0,
        nbrChefBrigade: 0,
        nbrChauffeur: 0,
        nbrComDePerm: 0,
        nbrSupervisor: 0
      },
      show1: false,
      e6: 1,
      tab: null,
      dialog: false,
      alert: false,
      fullPage: false,
      text: "",
      color: "",
      file: "",
      editedIndex: -1,
      errors: [],
      excelData: [],
      arrayAbs: [],
      hotSettings: {
        renderAllRows: false,          // Rendu virtuel
        viewportRowRenderingOffset: 'auto',  // Calcul dynamique
        data: [],
        colWidths: 100,
        width: "100%",
        height: "675px",
        fixedRowsTop: 0,
        columnSorting: true,
        sortIndicator: true,
        filters: true,
        selectionMode: "single",
        dropdownMenu: ["filter_by_condition", "filter_action_bar", "filter_operators", "filter_by_value"],
        licenseKey: "non-commercial-and-evaluation",
        stretchH: "all",
        minSpareRows: false,
        contextMenu: ["remove_row"],
        language: "fr-FR",
        customBorders: true,
        columnHeaders: true,
        rowHeaders: true,
        stretch: "all",
        readOnly: false,
        afterChange: this.afterChangeMe,
        beforeRemoveRow: this.beforeRemoveRowMe,
        afterFilter: this.afterFilter,
        afterLoadData: this.afterLoadData,
        currentRowClassName: 'rowHighlight',
        manualColumnResize: true,
        className: "htCenter htMiddle",
        hiddenColumns: {
          columns: [0],
          indicators: false
        },
        colHeaders: [
          "Id", "Nom poste", "Nom zone", "Nbr total agents", "Nbr hommes 'X-Ray'", "Nbr femmes 'X-Ray'", "Nbr hommes 'OJT X-Ray'", "Nbr femmes 'OJT X-Ray'",
          "Nbr 'OJT X-Ray'", "Nbr 'X-Ray'", "Nbr hommes 'Base'", "Nbr femmes 'Base'", "Nbr hommes 'OJT Base'", "Nbr femmes 'OJT Base'", "Nbr 'OJT Base'",
          "Nbr 'Base'", "Nbr hommes 'Formés'", "Nbr femmes 'Formées'", "Nbr 'Formé(e)s'", "Nbr 'Chefs de poste'", "Nbr 'Superviseurs'", "Nbr 'Cmdts de Permanence'",
          "Nbr 'Chauffeurs'", "Nbr 'Chef de Brigade'", "Date création"
        ],
        columns: [
          {title: "Id", width: "80px", readOnly: true},
          {
            title: "Nom poste",
            width: "350px",
            type: 'dropdown',
            renderer: customDropDownRender,
            allowInvalid: false,
            strict: true
          },
          {title: "Nom zone", width: "160px", readOnly: true},
          {title: "Nbr total agents", width: "250px"},
          {title: "Nbr hommes 'X-Ray'", width: "250px"},
          {title: "Nbr femmes 'X-Ray'", width: "250px"},
          {title: "Nbr hommes 'OJT X-Ray'", width: "250px"},
          {title: "Nbr femmes 'OJT X-Ray'", width: "250px"},
          {title: "Nbr 'OJT X-Ray'", width: "250px"},
          {title: "Nbr 'X-Ray'", width: "250px"},
          {title: "Nbr hommes 'Base'", width: "250px"},
          {title: "Nbr femmes 'Base'", width: "250px"},
          {title: "Nbr hommes 'OJT Base'", width: "250px"},
          {title: "Nbr femmes 'OJT Base'", width: "250px"},
          {title: "Nbr 'OJT Base'", width: "250px"},
          {title: "Nbr 'Base'", width: "250px"},
          {title: "Nbr hommes 'Formés'", width: "250px"},
          {title: "Nbr femmes 'Formées'", width: "250px"},
          {title: "Nbr 'Formé(e)s'", width: "250px"},
          {title: "Nbr 'Chefs de poste'", width: "250px"},
          {title: "Nbr 'Superviseurs'", width: "250px"},
          {title: "Nbr 'Cmdts de Permanence'", width: "250px"},
          {title: "Nbr 'Chauffeurs'", width: "250px"},
          {title: "Nbr 'Chef de Brigade'", width: "250px"},
          {title: "Actif", width: "100px", type: "checkbox"},
          {
            title: "Date création",
            width: "180px",
            dateFormat: "DD-MM-YYYY HH:mm:ss",
            correctFormat: true,
            type: "date",
            readOnly: true
          },
        ],
        cells: function (row, col, prop) {
          const cellProperties = {};

          const cellValue = this.instance.getSourceDataAtCell(row, 24);
          if (cellValue === false) {
            if (col !== 24) {
              cellProperties.readOnly = true;
            }
          }

          return cellProperties;
        }
      }
    }
  },
  created() {
    this.loadPostes()
    this.loadShifts()
    this.initEditedItem()
    this.getData()
  },

  computed: {
    FormIsValid() {
      return (
          this.editedItem.postName !== "" &&
          this.editedItem.zoneName !== "" &&
          this.editedItem.nbrAgentsTotal !== 0
      );
    },
    userRole() {
      return this.$store.getters.user.role;
    }
  },
  methods: {
    cleared() {
      this.searchName = "";
      this.getData();
    },
    search() {
      var query = this.isEmpty(this.searchName) ? this.searchName : this.searchName.toLowerCase()

      if (this.isEmpty(query)) {
        this.cleared()
      }

      var row;
      var col;
      var rLen;
      var cLen;
      var data = this.$refs.hotTable.hotInstance.getData();
      var array = [];
      for (row = 0, rLen = data.length; row < rLen; row++) {
        for (col = 1, cLen = Object.keys(data[row]).length; col < cLen; col++) {
          var x = Object.keys(data[row])[col];
          if (('' + data[row][x]).toLowerCase().indexOf(query) > -1) {
            array.push(data[row]);
            break;
          }
        }
      }
      this.$refs.hotTable.hotInstance.loadData(array);
    },
    init() {
      this.tab = "tab-1";
      this.file = "";
      this.files = [];
      this.fileBtn = true;
      this.drag_over = false;
    },
    dragEnter(e) {
      if (e.target === this.$refs.others)
        this.over_others = true
      else
        this.drag_over = true
    },
    dragOver(e) {
      if (e.target === this.$refs.others) this.over_others = true
      else this.drag_over = true
    },
    dragLeave(e) {
      if (e.target === this.$refs.others) this.over_others = false
      else if (!this.over_others) this.drag_over = false
    },
    afterSelectionEnd(r, c) {
      var i;
      if (this.lastHighlitedRow !== null) {
        for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
          this.$refs.hotTable.hotInstance.setCellMeta(this.lastHighlitedRow, i, 'className', 'htCenter htMiddle');
        }
      }

      for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
        this.$refs.hotTable.hotInstance.setCellMeta(r, i, 'className', 'area highlight, htCenter htMiddle');
      }
      this.lastHighlitedRow = r;

      this.$refs.hotTable.hotInstance.render()
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    isEmpty(str) {
      return (!str || 0 === str.length || /^\s*$/.test(str));
    },
    getData() {
      this.loading = true
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/account/dispatchingrules/` + sessionStorage.getItem("userId"), {timeout: 180000}
          )
          .then(response => {
            this.loading = false
            let tabArray = []
            let newObj = response.data.datas;

            if (response.data.status !== 200) {
              this.color = "#009688"
              this.text = response.data.message;
              this.showAlert('warning')
              this.disableMainBtn = true
            } else {
              this.disableMainBtn = false
            }

            String.prototype.capitalize = function (allWords) {
              return (allWords) ? // if all words
                  this.split(' ').map(word => word.capitalize()).join(' ') : //break down phrase to words then  recursive calls until capitalizing all words
                  this.charAt(0).toUpperCase() + this.slice(1); // if allWords is undefined , capitalize only the first word , mean the first char of the whole string
            }

            newObj.forEach((item) => {
              if (!(!this.isEmpty(item["postName"]) && (item["postName"].toUpperCase() === "TOUS POSTES") && (item["nbrAgentsTotal"] === 0))) {
                tabArray.push([
                  item["id"],
                  this.isEmpty(item["postName"]) ? "" : item["postName"].toUpperCase(),
                  this.isEmpty(item["zoneName"]) ? "" : item["zoneName"].toUpperCase(),
                  this.isEmpty(item["nbrAgentsTotal"]) ? "0" : item["nbrAgentsTotal"],
                  this.isEmpty(item["nbrMenXRay"]) ? "0" : item["nbrMenXRay"],
                  this.isEmpty(item["nbrWomenXRay"]) ? "0" : item["nbrWomenXRay"],
                  this.isEmpty(item["nbrMenOJTXRay"]) ? "0" : item["nbrMenOJTXRay"],
                  this.isEmpty(item["nbrWomenOJTXRay"]) ? "0" : item["nbrWomenOJTXRay"],
                  this.isEmpty(item["nbrOJTXRay"]) ? "0" : item["nbrOJTXRay"],
                  this.isEmpty(item["nbrXRay"]) ? "0" : item["nbrXRay"],
                  this.isEmpty(item["nbrMenBased"]) ? "0" : item["nbrMenBased"],
                  this.isEmpty(item["nbrWomenBased"]) ? "0" : item["nbrWomenBased"],
                  this.isEmpty(item["nbrMenOJTBased"]) ? "0" : item["nbrMenOJTBased"],
                  this.isEmpty(item["nbrWomenOJTBased"]) ? "0" : item["nbrWomenOJTBased"],
                  this.isEmpty(item["nbrOJTBased"]) ? "0" : item["nbrOJTBased"],
                  this.isEmpty(item["nbrBased"]) ? "0" : item["nbrBased"],
                  this.isEmpty(item["nbrMenFormed"]) ? "0" : item["nbrMenFormed"],
                  this.isEmpty(item["nbrWomenFormed"]) ? "0" : item["nbrWomenFormed"],
                  this.isEmpty(item["nbrFormed"]) ? "0" : item["nbrFormed"],
                  this.isEmpty(item["nbrChefPost"]) ? "0" : item["nbrChefPost"],
                  this.isEmpty(item["nbrSupervisor"]) ? "0" : item["nbrSupervisor"],
                  this.isEmpty(item["nbrComDePermanence"]) ? "0" : item["nbrComDePermanence"],
                  this.isEmpty(item["nbrDriver"]) ? "0" : item["nbrDriver"],
                  this.isEmpty(item["nbrChefBrigade"]) ? "0" : item["nbrChefBrigade"],
                  item["active"],
                  this.datefull(item["creationDate"])
                ])
              }
            })

            this.$refs.hotTable.hotInstance.loadData(tabArray)
            this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
          })
          .catch(() => {
            this.loading = false
          });
    },
    dynamicID() {
      return 'dynamicID-' + Math.floor(Math.random() * Date.now().toString());
    },
    loadShifts() {
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/account/shifts/` + sessionStorage.getItem("userId"), {timeout: 180000}
          )
          .then(response => {
            sessionStorage.setItem("Shifts", null)
            let datas = response.data.datas;
            this.shiftsFull = datas;
            this.shifts = []
            datas.forEach(item => {
              this.shifts.push(item.shiftName);
            });
            sessionStorage.setItem("Shifts", JSON.stringify(this.shifts))
          })
          .catch(() => {
          });
    },
    loadPostes() {
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/account/enableposts/` + sessionStorage.getItem("userId"), {timeout: 180000}
          )
          .then(response => {
            sessionStorage.setItem("PostesEnabled", null)

            let datas = response.data.datas;
            this.namePostsZones = [];
            this.namePosts = [];
            this.nameZones = [];
            datas.forEach(item => {
              this.namePosts.push(item.name.toUpperCase(true));
              this.nameZones.push(item.zone.toUpperCase(true));
              this.namePostsZones.push([item.name.toUpperCase(true), item.zone.toUpperCase(true)]);
            });

            this.namePosts.sort()
            sessionStorage.setItem("PostesEnabled", JSON.stringify(this.namePosts))

            this.namePostsZones.forEach(item2 => {
              let str1 = item2[0].toUpperCase()
              let str2 = this.editedItem.postName.toUpperCase()

              if (str1.localeCompare(str2) === 0) {
                this.editedItem.zoneName = item2[1];
              }
            })
          })
          .catch(() => {
          });
    },
    onCancel() {
      this.loading = false
    },
    refresh() {
      this.getData()
    },
    datefull(val) {
      if (!val) {
        return
      }
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY HH:mm:ss");
    },
    convertDate(val) {
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY");
    },
    close() {
      this.initEditedItem();
      this.radioGroup = 0;
      this.dialog = false;
      this.file = "";
      this.files = [];
      this.fileBtn = true;
      this.drag_over = false;
    },
    AlertColor(type) {
      return type === "info" ? "#4CAF50" : "#F44336";
    },
    showAlert(type) {
      this.type = type

      let timer = this.showAlert.timer
      if (timer) {
        clearTimeout(timer)
      }
      this.showAlert.timer = setTimeout(() => {
        this.type = null
      }, 20000)

      this.elapse = 1
      let t = this.showAlert.t
      if (t) {
        clearInterval(t)
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapse === 3) {
          this.elapse = 0
          clearInterval(this.showAlert.t)
        } else {
          this.elapse++
        }
      }, 5000)
    },
    dismissible_close() {
      this.elapse = 3
      clearTimeout(this.showAlert.timer)
      clearInterval(this.showAlert.t)
      this.type = null
    },
    closeAlert() {
      this.alert = false
      this.text = ""
      this.errors = []
    },
    onPickFile() {
      this.$refs.fileInput.click();
    },
    afterLoadData() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
    },
    afterFilter() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
    },
    afterChangeMe(changes, source) {
      if (changes !== null && source === "edit" && (changes[0][2] !== changes[0][3])) {
        let message = {
          title: 'Fenêtre de confirmation',
          body: 'Confirmez la modification de la règle.'
        };

        this.$dialog
            .confirm(message)
            .then(dialog => {
              this.initEditedItem();
              this.loading = true
              let obj = {}
              let newObj = {}

              obj = this.$refs.hotTable.hotInstance.getData()[changes[0][0]]

              if (obj[1] === "" || obj[2] === "") {
                this.text = "Les éléments de la section 'Informations générales' doivent être tous remplis."
                this.showAlert('warning')
                this.loading = false
                this.refresh()
                dialog.close();
                return;
              }

              if (!this.isInt(obj[3]) || !this.isInt(obj[4]) || !this.isInt(obj[5]) || !this.isInt(obj[6]) || !this.isInt(obj[7]) || !this.isInt(obj[8])
                  || !this.isInt(obj[9]) || !this.isInt(obj[10]) || !this.isInt(obj[11]) || !this.isInt(obj[12]) || !this.isInt(obj[13]) || !this.isInt(obj[14])
                  || !this.isInt(obj[15]) || !this.isInt(obj[16]) || !this.isInt(obj[17]) || !this.isInt(obj[18]) || !this.isInt(obj[19]) || !this.isInt(obj[20])
                  || !this.isInt(obj[21]) || !this.isInt(obj[22]) || !this.isInt(obj[23])) {
                this.text = "Le nombre d'agents doit être un entier."
                this.showAlert('warning')
                this.loading = false
                this.refresh()
                dialog.close();
                return;
              }

              let nbrAgentsRepartis = parseInt(obj[3]) - (parseInt(obj[4]) + parseInt(obj[5]) + parseInt(obj[6]) + parseInt(obj[7]) +
                  parseInt(obj[8]) + parseInt(obj[9]) + parseInt(obj[10]) + parseInt(obj[11]) + parseInt(obj[12]) + parseInt(obj[13]) +
                  parseInt(obj[14]) + parseInt(obj[15]) + parseInt(obj[16]) + parseInt(obj[17]) + parseInt(obj[18]) + parseInt(obj[19]) +
                  parseInt(obj[20]) + parseInt(obj[21]) + parseInt(obj[22]) + parseInt(obj[23]));

              if (nbrAgentsRepartis < 0) {
                this.text = "Le nombre total d'agents ne peut pas être inférieur à la somme des agents répartis par poste."
                this.showAlert('warning')
                this.loading = false
                this.refresh()
                dialog.close();
                return;
              }

              if (changes[0][1] === 1) {
                let i = 0
                this.namePosts.forEach(item => {
                  if (this.RemoveAccents(item.toLowerCase()) === this.RemoveAccents(obj[1].toLowerCase())) {
                    obj[2] = this.nameZones[i];
                  }
                  ++i;
                });
              }

              newObj = {
                "id": obj[0],
                "postName": obj[1],
                "zoneName": obj[2],
                "nbrAgentsTotal": obj[3],
                "nbrMenXRay": obj[4],
                "nbrWomenXRay": obj[5],
                "nbrMenOJTXRay": obj[6],
                "nbrWomenOJTXRay": obj[7],
                "nbrOJTXRay": obj[8],
                "nbrXRay": obj[9],
                "nbrMenBased": obj[10],
                "nbrWomenBased": obj[11],
                "nbrMenOJTBased": obj[12],
                "nbrWomenOJTBased": obj[13],
                "nbrOJTBased": obj[14],
                "nbrBased": obj[15],
                "nbrMenFormed": obj[16],
                "nbrWomenFormed": obj[17],
                "nbrFormed": obj[18],
                "nbrChefPost": obj[19],
                "nbrSupervisor": obj[20],
                "nbrComDePermanence": obj[21],
                "nbrDriver": obj[22],
                "nbrChefBrigade": obj[23],
                "active": obj[24],
                "revisedUser": sessionStorage.getItem("userId")
              }

              apiClient
                  .post(
                      `${this.$store.getters.user.baseUrl}/account/dispatchingrule/` + sessionStorage.getItem("userId"),
                      newObj
                  )
                  .then(res => {
                    dialog.close();
                    this.loading = false
                    if (res.data.status === 200) {
                      this.color = "#009688"
                      this.text = res.data.message;
                      this.showAlert('info')
                      this.getData()
                    } else {
                      this.alert = true
                      this.color = "#F44336"
                      this.alert = true
                      this.text = res.data.message;
                      this.dialog = false;

                      let myData = this.$refs.hotTable.hotInstance.getData()
                      myData[changes[0][0]][changes[0][1]] = changes[0][2]
                      this.$refs.hotTable.hotInstance.loadData(myData)
                      this.showAlert('warning')
                    }
                  })
                  .catch((err) => {
                    dialog.close();
                    let myData = this.$refs.hotTable.hotInstance.getData()
                    myData[changes[0][0]][changes[0][1]] = changes[0][2]
                    this.$refs.hotTable.hotInstance.loadData(myData)

                    this.alert = true
                    this.color = "#F44336"
                    this.text = err.data.message;
                    this.loading = false
                    this.showAlert('warning')
                  });
            })
            .catch(() => {
              let myData = this.$refs.hotTable.hotInstance.getData()
              myData[changes[0][0]][changes[0][1]] = changes[0][2]
              this.$refs.hotTable.hotInstance.loadData(myData)
            });
      }
    },
    beforeRemoveRowMe(index, amount) {
      let rowId = this.$refs.hotTable.hotInstance.getData()[index]
      let message = {
        title: 'Fenêtre de confirmation',
        body: 'Confirmez la suppression de la règle.'
      };

      this.$dialog
          .confirm(message)
          .then(dialog => {
            this.loading = true

            apiClient
                .delete(
                    `${this.$store.getters.user.baseUrl}/account/dispatchingrule/` + rowId[0] + "/" + sessionStorage.getItem("userId"), {timeout: 180000}
                )
                .then(res => {
                  dialog.close();
                  this.loading = false
                  if (res.data.status === 200) {
                    this.color = "#009688"
                    this.text = res.data.message;
                    this.showAlert('info')
                  } else {
                    this.$refs.hotTable.hotInstance.alter("insert_row_above", index)

                    this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 25, "readOnly", false);

                    this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowId]);

                    this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 25, "readOnly", true);

                    this.color = "#F44336"
                    this.alert = true
                    this.text = res.data.message;
                    this.dialog = false;
                    this.showAlert('warning')
                  }
                })
                .catch((error) => {
                  dialog.close();
                  this.loading = false
                  this.alert = true
                  this.color = "#F44336"
                  this.text = error;
                  this.showAlert('warning')
                });
          })
          .catch(() => {
            this.$refs.hotTable.hotInstance.alter("insert_row_above", index)

            this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 25, "readOnly", false);

            this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowId]);

            this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 25, "readOnly", true);
          });
    },
    initEditedItem() {
      this.editedItem.postName =
          this.editedItem.zoneName = "";

      this.editedItem.nbrAgentsTotal =
          this.editedItem.nbrMenXRay =
              this.editedItem.nbrMenOJTXRay =
                  this.editedItem.nbrOJTXRay =
                      this.editedItem.nbrXRay =
                          this.editedItem.nbrWomenXRay =
                              this.editedItem.nbrWomenOJTXRay =
                                  this.editedItem.nbrMenBased =
                                      this.editedItem.nbrWomenBased =
                                          this.editedItem.nbrMenOJTBased =
                                              this.editedItem.nbrWomenOJTBased =
                                                  this.editedItem.nbrOJTBased =
                                                      this.editedItem.nbrBased =
                                                          this.editedItem.nbrMenFormed =
                                                              this.editedItem.nbrWomenFormed =
                                                                  this.editedItem.nbrFormed =
                                                                      this.editedItem.nbrChefPost =
                                                                          this.editedItem.nbrChefBrigade =
                                                                              this.editedItem.nbrSupervisor =
                                                                                  this.editedItem.nbrComDePerm =
                                                                                      this.editedItem.nbrChauffeur = 0;
    },
    onFilePicked(e) {
      const files = e.target.files;
      this.file = this.$refs.fileInput.files[0];
      if (!files.length) {
        return;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.text = "Le format du fichier est incorrecte.\nMerci de choisir un format xls ou xlsx";
        this.showAlert('warning');
        return false;
      }
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0];
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], {defval: "", skipHidden: true});
          const excellist = [];
          for (var i = 0; i < ws.length; i++) {
            excellist.push(ws[i]);
          }
          this.total = excellist
              .map(item => item.montant)
              .reduce((prev, curr) => prev + curr, 0);
          this.excelData = excellist.map(function (item) {
            return Object.values(item);
          })
        } catch (e) {
          this.text = "Erreur de lecture du fichier !";
          this.showAlert('warning')
          return false;
        }
      }
      fileReader.readAsBinaryString(files[0]);
      const input = document.getElementById("upload");
      input.value = "";
    },
    creer() {
      this.loading = true
      this.dialog = false

      if (!this.isInt(this.editedItem.nbrAgentsTotal) || !this.isInt(this.editedItem.nbrMenXRay) || !this.isInt(this.editedItem.nbrMenOJTXRay) || !this.isInt(this.editedItem.nbrOJTXRay) || !this.isInt(this.editedItem.nbrWomenOJTXRay)
          || !this.isInt(this.editedItem.nbrWomenXRay) || !this.isInt(this.editedItem.nbrXRay) || !this.isInt(this.editedItem.nbrMenBased) || !this.isInt(this.editedItem.nbrWomenBased)
          || !this.isInt(this.editedItem.nbrMenOJTBased) || !this.isInt(this.editedItem.nbrOJTBased) || !this.isInt(this.editedItem.nbrWomenOJTBased) || !this.isInt(this.editedItem.nbrBased)
          || !this.isInt(this.editedItem.nbrMenFormed) || !this.isInt(this.editedItem.nbrWomenFormed) || !this.isInt(this.editedItem.nbrFormed)
          || !this.isInt(this.editedItem.nbrChefPost) || !this.isInt(this.editedItem.nbrSupervisor) || !this.isInt(this.editedItem.nbrComDePerm) || !this.isInt(this.editedItem.nbrChauffeur) || !this.isInt(this.editedItem.nbrChefBrigade)) {
        this.text = "Le nombre d'agents doit être un entier."
        this.showAlert('warning')
        this.loading = false
        return;
      }

      let nbrAgentsRepartis = parseInt(this.editedItem.nbrAgentsTotal) - (parseInt(this.editedItem.nbrMenXRay) + parseInt(this.editedItem.nbrWomenXRay) +
          parseInt(this.editedItem.nbrMenOJTXRay) + parseInt(this.editedItem.nbrOJTXRay) + parseInt(this.editedItem.nbrWomenOJTXRay) + parseInt(this.editedItem.nbrXRay) +
          parseInt(this.editedItem.nbrMenBased) + parseInt(this.editedItem.nbrWomenBased) + parseInt(this.editedItem.nbrMenOJTBased) + parseInt(this.editedItem.nbrOJTBased) +
          parseInt(this.editedItem.nbrWomenOJTBased) + parseInt(this.editedItem.nbrBased) + parseInt(this.editedItem.nbrMenFormed) +
          parseInt(this.editedItem.nbrWomenFormed) + parseInt(this.editedItem.nbrFormed) + parseInt(this.editedItem.nbrChefPost) + parseInt(this.editedItem.nbrSupervisor) +
          parseInt(this.editedItem.nbrComDePerm) + parseInt(this.editedItem.nbrChauffeur) + parseInt(this.editedItem.nbrChefBrigade));

      if (nbrAgentsRepartis < 0) {
        this.text = "Le nombre total d'agents ne peut pas être inférieur à la somme des agents répartis par poste."
        this.showAlert('warning')
        this.loading = false
        return;
      }

      const dataToSave = {
        postName: this.editedItem.postName,
        zoneName: this.editedItem.zoneName,
        nbrAgentsTotal: this.editedItem.nbrAgentsTotal,
        nbrMenXRay: this.editedItem.nbrMenXRay,
        nbrWomenXRay: this.editedItem.nbrWomenXRay,
        nbrMenOJTXRay: this.editedItem.nbrMenOJTXRay,
        nbrWomenOJTXRay: this.editedItem.nbrWomenOJTXRay,
        nbrOJTXRay: this.editedItem.nbrOJTXRay,
        nbrXRay: this.editedItem.nbrXRay,
        nbrMenBased: this.editedItem.nbrMenBased,
        nbrWomenBased: this.editedItem.nbrWomenBased,
        nbrMenOJTBased: this.editedItem.nbrMenOJTBased,
        nbrWomenOJTBased: this.editedItem.nbrWomenOJTBased,
        nbrOJTBased: this.editedItem.nbrOJTBased,
        nbrBased: this.editedItem.nbrBased,
        nbrMenFormed: this.editedItem.nbrMenFormed,
        nbrWomenFormed: this.editedItem.nbrWomenFormed,
        nbrFormed: this.editedItem.nbrFormed,
        nbrChefPost: this.editedItem.nbrChefPost,
        nbrSupervisor: this.editedItem.nbrSupervisor,
        nbrComDePerm: this.editedItem.nbrComDePerm,
        nbrDriver: this.editedItem.nbrChauffeur,
        nbrChefBrigade: this.editedItem.nbrChefBrigade
      };

      apiClient
          .post(
              `${this.$store.getters.user.baseUrl}/account/dispatchingrule/` + sessionStorage.getItem("userId"),
              dataToSave
          )
          .then(res => {
            this.loading = false
            if (res.data.status === 200) {
              this.color = "#009688"
              this.text = res.data.message;
              this.dialog = false;
              this.getData()
              this.showAlert('info')
              this.initEditedItem()
            } else {
              this.alert = true
              this.color = "#F44336"
              this.alert = true
              this.text = res.data.message;
              this.dialog = false;
              this.showAlert('warning')
            }
          })
          .catch(err => {
            this.alert = true
            this.text = err;
            this.dialog = false;
            this.loading = false
            this.color = "#F44336"
            this.showAlert('warning')
          });
    },
    RemoveAccents(sAccents) {
      var strAccents = sAccents.split('');
      var strAccentsOut = [];
      var strAccentsLen = strAccents.length;
      var accents = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
      var accentsOut = "AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz";
      for (var y = 0; y < strAccentsLen; y++) {
        if (accents.indexOf(strAccents[y]) !== -1) {
          strAccentsOut[y] = accentsOut.substr(accents.indexOf(strAccents[y]), 1);
        } else {
          strAccentsOut[y] = strAccents[y];
        }
      }
      strAccentsOut = strAccentsOut.join('');
      return strAccentsOut;
    },
    isInt(value) {
      var x = parseFloat(value);
      return !isNaN(value) && (x | 0) === x;
    },
    importFileToHandsonTable() {
      const vm = this;
      vm.loading = true
      vm.dialog = false;
      vm.file = ""
      let dataTosave = [];

      for (let i = 0; i < this.excelData.length; i++) {
        if (this.namePosts.findIndex(item => this.RemoveAccents(this.excelData[i][0].trim().toLowerCase()) === this.RemoveAccents(item.trim().toLowerCase())) < 0) {
          this.text = "Nom du poste '" + this.excelData[i][0] + "' inconnu -> Ligne " + (i + 2) + ". Merci de prendre exemple sur le modèle."
          this.showAlert('warning')
          this.loading = false
          return;
        }

        if (!this.isInt(this.excelData[i][1]) || !this.isInt(this.excelData[i][2]) || !this.isInt(this.excelData[i][3])
            || !this.isInt(this.excelData[i][4]) || !this.isInt(this.excelData[i][5]) || !this.isInt(this.excelData[i][6])
            || !this.isInt(this.excelData[i][7]) || !this.isInt(this.excelData[i][8]) || !this.isInt(this.excelData[i][9])
            || !this.isInt(this.excelData[i][10]) || !this.isInt(this.excelData[i][11]) || !this.isInt(this.excelData[i][12])
            || !this.isInt(this.excelData[i][13]) || !this.isInt(this.excelData[i][14]) || !this.isInt(this.excelData[i][15])
            || !this.isInt(this.excelData[i][16]) || !this.isInt(this.excelData[i][17]) || !this.isInt(this.excelData[i][18])
            || !this.isInt(this.excelData[i][19]) || !this.isInt(this.excelData[i][20]) || !this.isInt(this.excelData[i][21])) {
          this.text = "Le nombre d'agents doit être un entier."
          this.showAlert('warning')
          this.loading = false
          return;
        }

        let nbrAgentsRepartis = parseInt(this.excelData[i][1]) - (parseInt(this.excelData[i][2]) + parseInt(this.excelData[i][3]) +
            parseInt(this.excelData[i][4]) + parseInt(this.excelData[i][5]) + parseInt(this.excelData[i][6]) +
            parseInt(this.excelData[i][7]) + parseInt(this.excelData[i][8]) + parseInt(this.excelData[i][9]) +
            parseInt(this.excelData[i][10]) + parseInt(this.excelData[i][11]) + parseInt(this.excelData[i][12]) +
            parseInt(this.excelData[i][13]) + parseInt(this.excelData[i][14]) + parseInt(this.excelData[i][15]) +
            parseInt(this.excelData[i][16]) + parseInt(this.excelData[i][17]) + parseInt(this.excelData[i][18]) +
            parseInt(this.excelData[i][19]) + parseInt(this.excelData[i][20]) + parseInt(this.excelData[i][21]));

        if (nbrAgentsRepartis < 0) {
          this.text = "Le nombre total d'agents ne peut pas être inférieur à la somme des agents répartis par poste."
          this.showAlert('warning')
          this.loading = false
          return;
        }

        let j = 0
        let zoneNameTmp
        let namePost = this.excelData[i][0]
        this.namePosts.forEach(item => {
          if (this.RemoveAccents(item.toLowerCase()) === this.RemoveAccents(namePost.toLowerCase())) {
            zoneNameTmp = this.nameZones[j];
          }
          ++j;
        });

        dataTosave.push({
          postName: this.excelData[i][0],
          zoneName: zoneNameTmp,
          nbrAgentsTotal: this.excelData[i][1],
          nbrMenXRay: this.excelData[i][2],
          nbrWomenXRay: this.excelData[i][3],
          nbrMenOJTXRay: this.excelData[i][4],
          nbrWomenOJTXRay: this.excelData[i][5],
          nbrOJTXRay: this.excelData[i][6],
          nbrXRay: this.excelData[i][7],
          nbrMenBased: this.excelData[i][8],
          nbrWomenBased: this.excelData[i][9],
          nbrMenOJTBased: this.excelData[i][10],
          nbrWomenOJTBased: this.excelData[i][11],
          nbrOJTBased: this.excelData[i][12],
          nbrBased: this.excelData[i][13],
          nbrMenFormed: this.excelData[i][14],
          nbrWomenFormed: this.excelData[i][15],
          nbrFormed: this.excelData[i][16],
          nbrChefPost: this.excelData[i][17],
          nbrSupervisor: this.excelData[i][18],
          nbrComDePerm: this.excelData[i][19],
          nbrDriver: this.excelData[i][20],
          nbrChefBrigade: this.excelData[i][21]
        });
      }

      apiClient
          .post(
              `${vm.$store.getters.user.baseUrl}/account/dispatchingrules/` +
              sessionStorage.getItem("userId"),
              dataTosave
          )
          .then(res => {
            vm.loading = false
            if (res.data.status === 200) {
              let dataObj = []
              let dataError = []
              for (let i = 0; i < res.data.datas.length; i++) {
                if (res.data.datas[i].status === 200) {
                  dataObj.push(res.data.datas[i].datas);
                } else {
                  dataError.push(res.data.datas[i]);
                }
              }

              if (dataObj.length > 0 && dataError.length === 0) {
                vm.color = "#009688"
                vm.text = dataObj.length + " Règle(s) ajoutée(s)."
                vm.file = "";
                this.showAlert('info')
                this.getData()
              } else if (dataObj.length === 0 && dataError.length > 0) {
                vm.alert = true
                vm.color = "#F44336"
                vm.errors = dataError
                vm.file = "";
                this.getData()
              } else if (dataObj.length > 0 && dataError.length > 0) {
                vm.color = "#F44336"
                vm.errors = dataError
                vm.file = "";
                vm.alert = true
                this.getData()
              }
            }
          })
          .catch(err => {
            vm.alert = true
            vm.loading = false;
            vm.text = err;
            vm.dialog = false;
            vm.color = "#F44336"
            this.showAlert('warning')
          });
    },

    onexport() { // On Click Excel download button
      // export json to Worksheet of Excel
      // only array possible
      this.loading = true
      var datas = XLSX.utils.json_to_sheet(this.toObject, {skipHeader: true})
      // var pokemonWS = XLSX.utils.json_to_sheet(this.Datas.pokemons)

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, datas, "Règles_dispatching") // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, "pokemons")

      // export Excel file
      XLSX.writeFile(wb, "Règles_dispatching.xlsx") // name of the file is "book.xlsx"
      this.loading = false
    },

    onexportModele() { // On Click Excel download button
      this.loading = true

      var ws = XLSX.utils.json_to_sheet([
        {
          postName: "Nom poste",
          nbrAgentsTotal: "Nbr total agents",
          nbrMenXRay: "Nbr hommes 'X-Ray'",
          nbrWomenXRay: "Nbr femmes 'X-Ray'",
          nbrMenOJTXRay: "Nbr hommes 'OJT X-Ray'",
          nbrWomenOJTXRay: "Nbr femmes 'OJT X-Ray'",
          nbrOJTXRay: "Nbr 'OJT X-Ray'",
          nbrXRay: "Nbr 'X-Ray'",
          nbrMenBased: "Nbr hommes 'Base'",
          nbrWomenBased: "Nbr femmes 'Base'",
          nbrMenOJTBased: "Nbr hommes 'OJT Base'",
          nbrWomenOJTBased: "Nbr femmes 'OJT Base'",
          nbrOJTBased: "Nbr 'OJT Base'",
          nbrBased: "Nbr 'Base'",
          nbrMenFormed: "Nbr hommes 'Formés'",
          nbrWomenFormed: "Nbr femmes 'Formées",
          nbrFormed: "Nbr 'Formé(e)s",
          nbrChefPost: "Nbr 'Chefs de poste'",
          nbrSupervisor: "Nbr 'Superviseurs'",
          nbrComDePerm: "Nbr 'Cmdts de Permanence'",
          nbrDriver: "Nbr 'Chauffeurs'",
          nbrChefBrigade: "Nbr 'Chefs de Brigade'"
        },
        {
          postName: "Passerelle 2",
          nbrAgentsTotal: "11",
          nbrMenXRay: "1",
          nbrWomenXRay: "1",
          nbrMenOJTXRay: "0",
          nbrWomenOJTXRay: "1",
          nbrOJTXRay: "0",
          nbrXRay: "1",
          nbrMenBased: "0",
          nbrWomenBased: "1",
          nbrMenOJTBased: "0",
          nbrWomenOJTBased: "1",
          nbrOJTBased: "0",
          nbrBased: "1",
          nbrMenFormed: "0",
          nbrWomenFormed: "1",
          nbrFormed: "1",
          nbrChefPost: "2",
          nbrSupervisor: "1",
          nbrComDePerm: "0",
          nbrDriver: "1",
          nbrChefBrigade: "1"
        },
      ], {
        header: ["postName", "nbrAgentsTotal", "nbrMenXRay", "nbrWomenXRay", "nbrMenOJTXRay", "nbrWomenOJTXRay", "nbrOJTXRay", "nbrXRay", "nbrMenBased", "nbrWomenBased", "nbrMenOJTBased",
          "nbrWomenOJTBased", "nbrOJTBased", "nbrBased", "nbrMenFormed", "nbrWomenFormed", "nbrFormed", "nbrChefPost", "nbrSupervisor", "nbrComDePerm", "nbrDriver", "nbrChefBrigade"],
        skipHeader: true,
        cellDates: true
      });

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, ws, "Règles_dispatching_modèle") // sheetAName is name of Worksheet

      // export Excel file
      XLSX.writeFile(wb, "Règles_dispatching_modèle.xlsx", {cellDates: true}) // name of the file is "book.xlsx"
      this.loading = false
    },
    addFile(e) {
      let droppedFiles = e.dataTransfer.files;
      if (!droppedFiles) return;
      // this tip, convert FileList to array, credit: https://www.smashingmagazine.com/2018/01/drag-drop-file-uploader-vanilla-js/
      ([...droppedFiles]).forEach(f => {
        this.files.push(f);
      });

      let formData = new FormData();
      this.files.forEach((f, x) => {
        formData.append('file' + (x + 1), f);
      });

      if (!this.files.length) {
        return;
      } else if (!/\.(xls|xlsx)$/.test(this.files[0].name.toLowerCase())) {
        this.text = "Le format du fichier est incorrecte.\nMerci de choisir un format xls ou xlsx";
        this.showAlert('warning');
        return false;
      } else if (this.files.length !== 1) {
        this.text = "Nous ne traitons qu'un fichier excel";
        this.showAlert('warning');
        return false;
      }

      this.file = this.files[0];
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0];
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], {defval: "", skipHidden: true});
          const excellist = [];
          for (var i = 0; i < ws.length; i++) {
            excellist.push(ws[i]);
          }
          this.total = excellist
              .map(item => item.montant)
              .reduce((prev, curr) => prev + curr, 0);
          this.excelData = excellist.map(function (item) {
            return Object.values(item);
          })

          this.fileBtn = false;
        } catch (e) {
          this.text = "Erreur de lecture du fichier !";
          this.showAlert('warning')
          return false;
        }
      }
      fileReader.readAsBinaryString(this.file);
      const input = document.getElementById("upload");
      input.value = "";
    },
    removeFile(file) {
      this.loading = false
      this.fileBtn = true
      this.drag_over = false
      this.file = ""
      this.files = this.files.filter(f => {
        return f !== file;
      });
    },
  },
};
</script>

<style scoped>
.toolbar .v-toolbar__content {
  padding: 0 !important
}

.input-class {
  padding: 2px 0;
  border-bottom: solid 1px #999;
  color: #444;
  width: 100%;
}

.v-text-field {
  min-width: 222px;
}

.custom-btn {
  width: 222px;
}

.custom-btn::before {
  color: transparent
}

.custom-btn:hover {
  color: #F5F5F5 !important;
}
</style>
